import { isNull, isUndefined } from './is-type';

export function formatPercentage(value: number | null, decimals = 1) {
  if (value == null) {
    return '-';
  }

  return `${(value * 100).toFixed(decimals)}%`;
}

export function nullIfNotPositive(value: number | null | undefined) {
  if (isNull(value) || isUndefined(value)) {
    return null;
  }

  return value > 0 ? value : null;
}
